import { render, staticRenderFns } from "./BlockType109.vue?vue&type=template&id=175f65b4&scoped=true"
import script from "./BlockType109.vue?vue&type=script&lang=ts"
export * from "./BlockType109.vue?vue&type=script&lang=ts"
import style0 from "./BlockType109.vue?vue&type=style&index=0&id=175f65b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175f65b4",
  null
  
)

export default component.exports